import { AppRoute, type WidgetPropsType } from '@agentselly/immodossier-shared';
import { createFileRoute } from '@tanstack/react-router';
import { profileWidgets } from '~/config/widgets/profileWidgets';
import { useLoaderQuery } from '~/helper/useLoaderQuery';
import { LoadingWidget } from '~/components/widget/base/LoadingWidget';
import { RenderWidgets } from '~/components/widget/RenderWidgets';
import { ErrorWidget } from '~/components/widget/base/ErrorWidget';
import { EmptyWidget } from '~/components/widget/base/EmptyWidget';
import { useAppParams } from '~/helper/useAppParams';
import { useTranslate } from '@tolgee/react';

export const Route = createFileRoute(
  AppRoute.$LANG_$COMPANYID_$CONTACTID_PROFILE,
)({
  component: Body,
});

function Body() {
  const { t } = useTranslate();
  const params = useAppParams(Route);

  const query = useLoaderQuery(AppRoute.$LANG_$COMPANYID_$CONTACTID_PROFILE, {
    params,
  });

  if (query.isLoading) {
    return <LoadingWidget />;
  }

  if (query.isError) {
    return (
      <ErrorWidget
        error={query.error}
        onRetry={() => query.refetch()}
        isRetrying={query.isFetching && !query.isLoading}
      />
    );
  }

  if (!query.data) {
    return <EmptyWidget />;
  }

  const data = query.data as {
    readonly widgetProps?: WidgetPropsType;
    readonly v3Redesign?: boolean;
  };
  const widgetProps = data.widgetProps;

  if (
    !widgetProps ||
    typeof widgetProps !== 'object' ||
    Object.keys(widgetProps).length === 0
  ) {
    return <EmptyWidget />;
  }

  if (!data.v3Redesign) {
    return <RenderWidgets widgets={profileWidgets(widgetProps)} />;
  }

  return (
    <div className="v3-stack">
      <div
        className="v3-head"
        data-od-id="page-head"
      >
        <h1>{t('profile_page_title', 'Profil')}</h1>
        <p>{t('profile_page_subtitle', 'Ihre Angaben und Ihr Konto.')}</p>
      </div>
      <RenderWidgets widgets={profileWidgets(widgetProps)} />
    </div>
  );
}
